import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { Shipment } from '@qwyk/shared-stores/shipments';

import { ShipmentTimelineEvent } from './shipment-timeline-events.models';
import * as ShipmentTimelineEventsActions from './shipment-timeline-events.actions';
import * as ShipmentTimelineEventsSelectors from './shipment-timeline-events.selectors';

@Injectable()
export class ShipmentTimelineEventsFacade {
    /**
     * Combine pieces of state using createSelector,
     * and expose them as observables through the facade.
     */
    loading$ = this.store.pipe(
        select(ShipmentTimelineEventsSelectors.getShipmentTimelineEventsLoading)
    );
    allShipmentTimelineEvents$ = this.store.pipe(
        select(ShipmentTimelineEventsSelectors.getAllShipmentTimelineEvents)
    );
    selectedShipmentTimelineEvents$ = this.store.pipe(
        select(ShipmentTimelineEventsSelectors.getSelected)
    );
    error$ = this.store.pipe(
        select(ShipmentTimelineEventsSelectors.getShipmentTimelineEventsError)
    );

    constructor(private store: Store) {}

    /**
     * Use the initialization action to perform one
     * or more tasks in your Effects.
     */
    public init(shipment: Shipment) {
        this.store.dispatch(ShipmentTimelineEventsActions.init({ shipment }));
    }

    public update(
        shipment: Shipment,
        shipmentTimelineEvent: ShipmentTimelineEvent,
        changes: Partial<ShipmentTimelineEvent>
    ): void {
        this.store.dispatch(
            ShipmentTimelineEventsActions.updateShipmentTimelineEvent({
                shipment,
                shipmentTimelineEvent,
                changes,
            })
        );
    }

    public confirm(
        shipment: Shipment,
        shipmentTimelineEvent: ShipmentTimelineEvent,
        changes: Partial<ShipmentTimelineEvent>
    ): void {
        this.store.dispatch(
            ShipmentTimelineEventsActions.confirmShipmentTimelineEvent({
                shipment,
                shipmentTimelineEvent,
                changes,
            })
        );
    }

    public select(shipmentTimelineEvent: ShipmentTimelineEvent): void {
        this.selectById(shipmentTimelineEvent.id);
    }

    public selectById(selectedId: string): void {
        this.store.dispatch(
            ShipmentTimelineEventsActions.selectShipmentTimelineEvent({
                selectedId,
            })
        );
    }

    public unselect() {
        this.store.dispatch(
            ShipmentTimelineEventsActions.unselectShipmentTimelineEvent()
        );
    }

    public dismissError(): void {
        this.store.dispatch(ShipmentTimelineEventsActions.dismissError());
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public create(shipment: Shipment, payload: any) {
        this.store.dispatch(
            ShipmentTimelineEventsActions.createShipmentTimelineEvent({
                shipment,
                payload,
            })
        );
    }
}
